  <!-- Header Start -->
  <header class="hdrarea exam new"  *ngIf="(is_exam_started) && timer_header_for_routes.includes(current_route_url); else notInExam">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <a class="logo" (click)="logoClicked($event)"><img class="logo-img" src="assets/img/marketing-page-logo.png" alt="Infinity Learn"> </a>
          <div class="hamburger-menu"> <span></span> <span></span> <span></span> </div>
          <div class="logo-right">
            <!-- <p class="exam-type m-hide">{{examInfo.rulename}}</p> -->
            <div class="exam-settings">
             
              <div class="dropdown instruction-dropdown UNFAPP-m-hide">
                <button class="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  <img src="assets/img/bulb-icon.svg" alt="Instructions"> Instructions
                </button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" (click)="goToInstructionPage()" href="javascript:void(0)">General Instructions</a>
                </div>
              </div>

              <div class="dropdown instruction-dropdown UNFAPP-m-hide">
                <button class="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  <img src="assets/img/list-icon.svg" alt="Question List"> Questions
                </button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" (click)="goToQList()" href="javascript:void(0)">Question List</a>
                </div>
              </div>

              <div class="exam-timer" *ngIf="examInfo && !examInfo?.isLCAssignment">
                <p class="tmr-text">
                  <!-- <img class="icon-18 UNFAPP-m-hide" src="assets/img/yellow-clock-icon.svg" alt="">  -->
                  <img class="icon-18 _m-show d-inline-block" src="assets/img/yellow-clock-icon.svg" alt=""> 
                  <span class="m-show d-inline-block">Remaining:</span> 
                  <span class="m-hide">Time remaining:</span>
                  <span [ngClass]="{ 'in_warning' : timerWarning }" class="assessment_pl-2" #timerTickerDisplay>
                  </span> 
                </p>
              </div>
              <button [disabled]="examInfo.issubmitted || submitRequestMade" class="btn-login" type="button" data-toggle="modal" data-target="#finishTestModal" (click)="confirmingSubmit()" [ngClass]="{'mob-shift-lft' : examInfo.examtype == 'SCOREAWAT'}">SUBMIT</button>
              <!-- //? web -->
              <ng-container *ngIf="!mobileWidth">
                <button class="calling-btn" type="button"(click) = "copyNumber()" *ngIf="examInfo.examtype == 'SCOREAWAT'">
                  <img src="assets/img/calling-icon.svg" class="icn" />
                </button>
              </ng-container>
              <!-- //? mobile -->
              <ng-container *ngIf="mobileWidth">
                <a href="tel:18004194247"> <!-- //?open diapad in phone -->
                  <button class="calling-btn" type="button"  *ngIf="examInfo.examtype == 'SCOREAWAT'">
                    <img src="assets/img/calling-icon.svg" class="icn" />
                  </button>
                </a>
              </ng-container>

        <button class="UNFAPP-copybutton" *ngIf="showCopyOption" ><img src="assets/img/Copy-icon.svg" alt="" class="UNFAPP-copyicon" /><span class="UNFAPP-tooltip" >18004194247 </span> <span class="ml-2">Copied</span></button>

            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <!-- Header End -->
  <ng-template #notInExam>
    <header class="hdrarea without-exam" [class.home]="current_route_url=='/'" *ngIf='isAuthenticated' [ngClass]="{'ytvideopage-header':disableForYtVideosMweb}">
      <div class="container-fluid">
        <div class="row" *ngIf="!disableForYtVideosMweb">
          <div class="col-12 ">
           
            <!-- <a class="logo withtoolbar" (click)="logoClicked($event)"><img class="logo-img" src="assets/img/marketing-page-logo.png" alt="Infinity Learn"></a> -->
            <a class="logo withtoolbar" (click)="logotooltip('stay', 'logo')"><img class="logo-img" src="assets/img/marketing-page-logo.png" alt="Infinity Learn"> 
            </a>
            <div class="logo-tooltip"  [ngClass]="logotooltipstatus?'show':''">
              <h3 class="logo-tooltip-hdng">You are almost there! Final step remaining in in completing the order!</h3>
              <div class="logo-tooltip-actn-area">
                <button class="logo-tooltip-btn outline-btn" (click)="logotooltip('home', 'logo')">Go to home</button>
                <button class="logo-tooltip-btn" (click)="logotooltip('stay', 'logo')">Stay here</button>
              </div>
            </div>
            <div class="hamburger-menu"  *ngIf="!isAuthenticated"> <span></span> <span></span> <span></span> </div>
            
            <div class="logo-right">
                <a class="m-logo" (click)="logoClicked($event)"><img src="assets/img/marketing-page-logo.png" alt="Infinity Learn"> </a>
              <!-- <nav>
                <ul>
                    <li class="nav-item dropdown" *ngIf="!isAuthenticated">
                      <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">
                        Courses
                      </a>
                      <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item mh-link" routerLink="/neet">
                          NEET</a>
                        <a class="dropdown-item mh-link" routerLink="/jee">
                          JEE</a>
                      </div>
                    </li>
                    <li class="nav-item dropdown" *ngIf="!isAuthenticated &&  tenant!=='srichaitanya'">

                      <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"

                        aria-expanded="false">

                        Scholarship Test

                      </a>

                      <div class="dropdown-menu" aria-labelledby="navbarDropdown">

                        <a class="dropdown-item mh-link" routerLink="/ilite">

                          ILITE</a>

                      </div>

                    </li>
                    <li class="nav-item" *ngIf="!isAuthenticated">
                      <a class="nav-link mh-link" routerLink="/about">About Us</a>
                    </li>
                </ul>
              </nav>
              <div class="btn-group profile-btn-group IL_res-profile-btn" *ngIf="isAuthenticated">
                <button type="button" class="dropdown-toggle" data-toggle="dropdown"
                   aria-haspopup="true" aria-expanded="false">
                   <img [src]="profilePhoto" (error)="setDefaultPic()" alt="" class="IL_profile-img">
                </button>
                  <div class="dropdown-menu dropdown-menu-lg-right">
                      <button class="dropdown-item" type="button" (click)="showMyProfile()">
                        <img src="assets/img/edit-profile-icon-dark.svg" alt="Edit Profile">Profile
                      </button>

                      <button class="dropdown-item" type="button" (click)="logout()">
                        <img src="assets/img/logout-icon-dark.svg" alt="Logout">
                        Logout
                      </button>
                </div>
              </div> -->
              <!-- <ng-container>
                <button *ngIf="!isAuthenticated" class="btn-login mh-link" type="button" data-toggle="modal" (click)="openLoginForm()">LOGIN</button>
              </ng-container> -->
              <span class="m-overlay"></span>
            </div>
            <div class="btn-group profile-btn-group IL_res-profile-btn UNFAPP-d-hide" *ngIf="isAuthenticated && focusExamDopdown">
              <button class="UNFAPP-tpblu-subjctlink UNFAPP-gaptopbtn" (click)="openFocusExamDialog()" *ngIf="user?.exams.length > 1 && !router.url.includes('/testlist') && !router.url.includes('/subscription/proceed-to-payment') && !router.url.includes('/subscription/subscriptionPackages') && !router.url.includes('/subscribedPackages')">{{displayExamName}} - {{displayGrade}}<i class="fa fa-caret-down UNFAPP-gradedropdown" aria-hidden="true"></i></button>
            </div>
            <div class="btn-group profile-btn-group IL_res-profile-btn UNFAPP-m-hide" *ngIf="isAuthenticated">
              <!-- <button type="type" class="hdr-bell-btn">
                <img src="assets/img/bell-new-icon.svg" alt="" class="hd-bell-icon" />
              </button> -->

                <button type="button" class="dropdown-toggle" data-toggle="dropdown"
                   aria-haspopup="true" aria-expanded="false">
                 <img src="{{profileImagePath + profilePhoto}}" (error)="setDefaultPic()" alt="" class="IL_profile-img" *ngIf="!profilePic">
                 <div class="profile-letter-dp" *ngIf="profilePic">
                  {{user.firstName.charAt(0).toUpperCase() + user.lastName.charAt(0).toUpperCase()}}
                 </div>
                </button>
                  <div class="dropdown-menu dropdown-menu-lg-right">
                      <button class="dropdown-item" type="button" (click)="showMyProfile()">
                        <img src="assets/img/edit-profile-icon-dark.svg" alt="Edit Profile">Profile
                      </button>

                      <button class="dropdown-item" type="button" (click)="logout()">
                        <img src="assets/img/logout-icon-dark.svg" alt="Logout">
                        Logout
                      </button>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </ng-template>